import { render, staticRenderFns } from "./dashDespachante.vue?vue&type=template&id=27007448&scoped=true&"
import script from "./dashDespachante.vue?vue&type=script&lang=js&"
export * from "./dashDespachante.vue?vue&type=script&lang=js&"
import style0 from "./dashDespachante.vue?vue&type=style&index=0&id=27007448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27007448",
  null
  
)

export default component.exports